import { KettleIcon } from './KettleIcon';

/**
 * author: Simran
 * id C4476901-9B29-410C-BCA7-67814F5421B4
 * name kettle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const TeaKettleIcon = KettleIcon;
export default TeaKettleIcon